/*
 * O estado dos modelos no composer e o acesso a eles: o índice que o servidor
 * manda em toda página (`canelaTemplates`: id, nome, tipo, tags), os modelos
 * que valem para as tags escolhidas e o modelo inteiro (texto e campos), que
 * desce pela API quando é escolhido e fica guardado até sair da página.
 */
import app from 'flarum/forum/app';
import { forumBool } from '../../utils/settings';
import { templateFrom } from '../../../common/templates';
export function newState() {
  return {
    tagKey: null,
    candidates: [],
    selected: null,
    template: null,
    loading: false,
    request: 0,
    values: {},
    applied: null,
    backup: null,
    invalid: new Set()
  };
}
export function templatesOn() {
  return forumBool('canelaTemplatesEnabled', true);
}
export function templatesIndex() {
  const value = app.forum?.attribute('canelaTemplates');
  return Array.isArray(value) ? value : [];
}

/** Os modelos que valem para as tags escolhidas: os sem tag e os de alguma delas. */
export function candidatesFor(tagIds) {
  if (!templatesOn()) return [];
  const chosen = new Set(tagIds.map(Number));
  return templatesIndex().filter(template => template.tags.length === 0 || template.tags.some(id => chosen.has(id)));
}
const cache = new Map();

/** O modelo inteiro, pedido uma vez por página. */
export function loadTemplate(id) {
  let pending = cache.get(id);
  if (!pending) {
    const apiUrl = (app.forum.attribute('apiUrl') || '/api').replace(/\/+$/, '');
    pending = app.request({
      method: 'GET',
      url: `${apiUrl}/canela-templates/${id}`
    }).then(document => templateFrom(document.data));

    // Falhou: o próximo pedido tenta de novo.
    pending.catch(() => cache.delete(id));
    cache.set(id, pending);
  }
  return pending;
}
flarum.reg.add('ramon-canela', 'forum/features/templates/model', { newState: newState,templatesOn: templatesOn,templatesIndex: templatesIndex,candidatesFor: candidatesFor,loadTemplate: loadTemplate, });